import VerticalLine from "components/verticalLine";
import { contactSelector } from "data/selectors/contact";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router";
import { ClientSection } from "./clientSection";
import { FunctionSection } from "./functionSection";
import { SideSection } from "./sideSection";
import ConeIcon from "../../assets/common/ConeIcon.js";
import {
  FormContainer,
  LargeText,
  MediumText,
  ScreenRoot,
  SideContainer,
  StyledArea,
  StyledBox,
  StyledSpan,
} from "./styles";
import BuyerIcon from "assets/landingToolsBarIcons/buyerIcon";
import ContractorIcon from "assets/landingToolsBarIcons/contractorIcon";
import {
  serviceProviderBuyerListSelector,
  serviceProviderContractorsListSelector,
} from "data/selectors/serviceProvider";
import {
  getServiceProviderBuyersList,
  getServiceProviderContractorsList,
} from "data/actions/serviceProvider";
import ContractorAgentDashboard from "./contractorAgentDashboard";
import UnderwriterIcon from "../../assets/landingToolsBarIcons/underwriterIcon";
import { userSelector } from "../../data/selectors/user";
import { FunctionalButton } from "../../components/functionalButton";

function ServiceProviderDashboard() {
  const isMobile = useMediaQuery({ maxWidth: 480 });
  const [userData, setUserData] = useState("");
  const dispatch = useDispatch();
  const contactData = useSelector(contactSelector);
  let history = useHistory();
  const serviceProviderBuyerData = useSelector(
    serviceProviderBuyerListSelector,
  );
  const serviceProviderContractorData = useSelector(
    serviceProviderContractorsListSelector,
  );

  const user = JSON.parse(localStorage.getItem("User"));

  useEffect(() => {
    if (serviceProviderBuyerData?.length < 1) {
      dispatch(getServiceProviderBuyersList());
    }

    if (serviceProviderContractorData?.length < 1) {
      dispatch(getServiceProviderContractorsList());
    }
    localStorage.removeItem("current_agent_dashboard");
  }, []);

  useEffect(() => {
    if (
      serviceProviderContractorData?.data?.length > 0 &&
      serviceProviderBuyerData?.data?.length < 1
    ) {
      history.push("/service-provider-dashboard/contractor-client");
    }
    if (
      serviceProviderContractorData?.data?.length < 1 &&
      serviceProviderBuyerData?.data?.length > 0
    ) {
      history.push("/service-provider-dashboard/buyer-client");
    }
  }, [serviceProviderBuyerData, serviceProviderContractorData]);
  return (
    <ScreenRoot isMobile={isMobile}>
      <FormContainer isMobile={isMobile}>
        {serviceProviderContractorData?.data?.length > 0 &&
          serviceProviderBuyerData?.data?.length > 0 && (
            <>
              <LargeText isMobile={isMobile} style={{ textAlign: "center", marginBottom: "60px" }}>
                {isMobile ? "Select Module" : "What Do You Want to Do Today?"}
              </LargeText>
              <StyledArea style={{ marginTop: "20px", justifyContent: "center", gap: "30px" }}>
                <StyledBox
                  boxHeight="auto"
                  borderRadius="20px"
                  isMobile={isMobile}
                  style={{ 
                    cursor: "pointer", 
                    padding: "40px 30px", 
                    minHeight: "350px", 
                    width: "500px"
                  }}
                  flexDirection="column"
                  onClick={() => {
                    history.push("/service-provider-dashboard/buyer-client");
                    localStorage.setItem(
                      "current_agent_dashboard",
                      "/service-provider-dashboard/buyer-client",
                    );
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <BuyerIcon />
                  </div>
                  <MediumText isMobile={isMobile} style={{ textAlign: "center", fontSize: "20px", fontWeight: "600", marginTop: "20px", width: "100%", lineHeight: "1.4" }}>
                    Assist a Buyer to Prequalify Contractors
                  </MediumText>
                </StyledBox>

                <StyledBox
                  boxHeight="auto"
                  borderRadius="20px"
                  isMobile={isMobile}
                  style={{ 
                    cursor: "pointer", 
                    padding: "40px 30px", 
                    minHeight: "350px", 
                    width: "500px"
                  }}
                  flexDirection="column"
                  onClick={() => {
                    // Check subscription status for Agent/Broker and Buyer & Contractor users
                    const userType = user?.userType;
                    const userSubscribed = localStorage.getItem("user_subscribed") === "true";
                    const shouldCheckSubscription = (userType === "Agent/Broker" || userType === "Buyer & Contractor");
                    
                    if (shouldCheckSubscription && !userSubscribed) {
                      history.push("/subscribe");
                    } else {
                      history.push(
                        "/service-provider-dashboard/contractor-client",
                      );
                      localStorage.setItem(
                        "current_agent_dashboard",
                        "/service-provider-dashboard/contractor-client",
                      );
                    }
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ContractorIcon />
                  </div>
                  <MediumText isMobile={isMobile} style={{ textAlign: "center", fontSize: "20px", fontWeight: "600", marginTop: "20px", width: "100%", lineHeight: "1.4" }}>
                    Assist a Contractor to Prequalify for Jobs
                  </MediumText>
                </StyledBox>

                {user.is_agent_to_access_esub_and_idp && (
                  <StyledBox
                    boxHeight="auto"
                    borderRadius="20px"
                    isMobile={isMobile}
                    onClick={() => {
                      history.push("/underwriter-dashboard");
                    }}
                    style={{ 
                      cursor: "pointer", 
                      padding: "40px 30px", 
                      minHeight: "350px", 
                      width: "500px"
                    }}
                    flexDirection="column"
                  >
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <UnderwriterIcon />
                    </div> 
                    <MediumText isMobile={isMobile} style={{ textAlign: "center", fontSize: "20px", fontWeight: "600", marginTop: "20px", width: "100%", lineHeight: "1.4", height: "56px" }}>
                      Assist a Contractor to get Bonds
                    </MediumText>
                  </StyledBox>
                )}
              </StyledArea>
            </>
            // ) : (
            //   <>
            //     {serviceProviderContractorData?.data?.length > 0 &&
            //       serviceProviderBuyerData?.data?.length < 1 && (
            //         <ContractorAgentDashboard />
            //       )}
            //     {serviceProviderContractorData?.data?.length < 1 &&
            //       serviceProviderBuyerData?.data?.length > 0 && (
            //         <ContractorAgentDashboard />
            //       )}
            //   </>
          )}
        {!serviceProviderContractorData?.data?.length > 0 &&
          !serviceProviderBuyerData?.data?.length > 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "15%",
              }}
            >
              <ConeIcon />
              <LargeText
                isMobile={isMobile}
                style={{ textAlign: "center", lineHeight: "40px" }}
              >
                {
                  "There are no clients assigned to you on PledgX, please contact customer success team at support@pledgx.ai to add your clients."
                }
              </LargeText>
            </div>
          )}
      </FormContainer>
    </ScreenRoot>
  );
}

export default ServiceProviderDashboard;
